module.exports = __webpack_public_path__ + "assets/img/2022_06.1f82821f.png";